import React from 'react';
import Grid from 'components/elements/Grid';
import FieldSetWithTitle from 'shared/FieldSetWithTitle/components/FieldSetWithTitle';
import { ContractSelectGroup } from '../ContractFields';
import Checkbox from 'shared/Checkbox';
import Search from 'components/elements/Search';

export const ContractClosure = ({
  contractClosureReasonIdField,
  contractClosureReasonId,
  setContractClosureReasonId,
  contractCancellationReasonIdField,
  contractCancellationReasonId,
  setContractCancellationReasonId,
  cancelContractChecked,
  setCancelContractChecked,
  closeContractChecked,
  setCloseContractChecked,
  replacementContractIdField,
  replacementContractId,
  setReplacementContractId,
  replaceChecked,
  setReplaceChecked,
}) => {
  return (
    <FieldSetWithTitle title={I18n.translate('contracts.form.close_or_cancel')}>
      <div className='l-item-stack'>
        {contractClosureReasonIdField?.visible && (
          <>
            <Checkbox
              icon='tick'
              inline={true}
              checked={closeContractChecked}
              disabled={
                contractClosureReasonIdField?.disabled ||
                contractClosureReasonIdField?.readonly
              }
              label={I18n.translate('contracts.form.close_contract')}
              onChange={setCloseContractChecked}
            />
            {closeContractChecked && (
              <Grid grid={16}>
                <ContractSelectGroup
                  field={contractClosureReasonIdField}
                  value={contractClosureReasonId}
                  onChange={setContractClosureReasonId}
                />
              </Grid>
            )}
          </>
        )}
        {contractCancellationReasonIdField?.visible && (
          <>
            <Checkbox
              icon='tick'
              inline={true}
              checked={cancelContractChecked}
              disabled={
                contractCancellationReasonIdField?.disabled ||
                contractCancellationReasonIdField?.readonly
              }
              label={I18n.translate('contracts.form.cancel_contract')}
              onChange={setCancelContractChecked}
            />
            {cancelContractChecked && (
              <Grid grid={16}>
                <ContractSelectGroup
                  field={contractCancellationReasonIdField}
                  value={contractCancellationReasonId}
                  onChange={setContractCancellationReasonId}
                />
              </Grid>
            )}
            {cancelContractChecked &&
              contractCancellationReasonId &&
              replacementContractIdField?.visible && (
                <>
                  <Checkbox
                    icon='tick'
                    inline={true}
                    checked={replaceChecked}
                    disabled={
                      replacementContractIdField?.disabled ||
                      replacementContractIdField?.readonly
                    }
                    label={I18n.translate('contracts.form.replace_with_contract')}
                    onChange={(checked) => {
                      setReplaceChecked(checked);
                      if (!checked) setReplacementContractId('');
                    }}
                  />
                  {replaceChecked && replacementContractIdField?.readonly && (
                    <Grid grid={16}>
                      {/* Cancelled contract: show the linked replacement read-only (main_identifier). */}
                      <ContractSelectGroup
                        field={replacementContractIdField}
                        value={replacementContractId}
                        onChange={setReplacementContractId}
                      />
                    </Grid>
                  )}
                  {replaceChecked && !replacementContractIdField?.readonly && (
                    <Grid grid={16}>
                      <Search
                        name='contract[replacement_contract_id]'
                        value={
                          replacementContractId
                            ? Number(replacementContractId)
                            : undefined
                        }
                        options={(replacementContractIdField.options || []).map(
                          (option) => ({ value: option.id, label: option.name })
                        )}
                        placeholder={I18n.translate(
                          'contracts.form.select_replacement_contract'
                        )}
                        onChange={(option) =>
                          setReplacementContractId(option ? String(option.value) : '')
                        }
                        onClear={() => setReplacementContractId('')}
                      />
                      {/* Hidden but validatable mirror: makes the replacement mandatory
                          (native form validation) when the user opts to replace. */}
                      <input
                        tabIndex={-1}
                        required={true}
                        value={replacementContractId}
                        onChange={() => undefined}
                        style={{
                          opacity: 0,
                          height: 0,
                          width: 0,
                          position: 'absolute',
                        }}
                      />
                    </Grid>
                  )}
                </>
              )}
          </>
        )}
      </div>
    </FieldSetWithTitle>
  );
};
